import EmoteSelectorContainer from './EmoteSelector.container';
import EmoteSelector from './EmoteSelector';
export { default as EmoteSelectorPortal } from './Portal';
export default EmoteSelectorContainer(EmoteSelector);
